export default __webpack_public_path__ + "static/media/OpenSans-SemiBold.d8e49ca1.ttf";